import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
export var GraphPanel;
(function (GraphPanel) {
    let Type;
    (function (Type) {
        Type[Type["Climatic"] = 0] = "Climatic";
        Type[Type["ML_753"] = 1] = "ML_753";
    })(Type = GraphPanel.Type || (GraphPanel.Type = {}));
    GraphPanel.get = createAccessors(arrayGetSet('graph_panels'), {
        serial: '',
        name: 'Панель',
        recipient_address: 1,
        circuit_id_in_main_panel: -1,
        type: Type.Climatic,
    });
})(GraphPanel || (GraphPanel = {}));
